module.exports = __webpack_public_path__ + "static/media/lobbyBG.f0bcbc6c.svg";